export type DiscoveryIcp = {
  readonly jobTitles: readonly string[]
  readonly industries: readonly string[]
  readonly companySizes?: readonly string[]
  readonly locations?: readonly string[]
}

/**
 * Which ICP the first lead search runs on, at the end of onboarding (S6).
 *
 * Step 4 shows the AI's ICP suggestions in the ICP form, and its Next saves
 * the form with any changes the user made there. The search used to run on
 * the unsaved AI suggestions whenever there were any, so edits made in step 4
 * never reached it. Once step 4 has been saved, the saved ICP wins; the AI
 * suggestions are used only when step 4 was skipped or nothing was saved.
 */
export function discoveryIcp(
  saved: DiscoveryIcp | null,
  generated: DiscoveryIcp | null,
  icpStepSaved: boolean,
): DiscoveryIcp | null {
  const usable = (icp: DiscoveryIcp | null): icp is DiscoveryIcp => !!icp && icp.jobTitles.length > 0

  if (icpStepSaved && usable(saved)) return saved
  if (usable(generated)) return generated
  if (usable(saved)) return saved
  return null
}
